module.exports = __webpack_public_path__ + "media/entities/29-5fc257d9.png";